import {store} from '../App';

export function getTranslation(object, acceptDefaultValue=true, fallbackToEnglish=false) {
    const languageCode = getLocale();

    if (languageCode && object && object[languageCode]) {
        return object[languageCode];
    }

    if (acceptDefaultValue && object && (object.defaultValue || object.defaultValue === "")) {
        return object.defaultValue;
    }

    // only used for "go by spark", because they don't support "defaultValue"
    if (fallbackToEnglish && object && object.en) {
        return object.en;
    }

    return "";
}

export function getLocale() {
    return store.getState().i18nState.lang;
}

export function getLocalizedImage(imageName) {
    const languageCode = getLocale();

    try {
        return require(`../resources/images/${languageCode}_${imageName}`)
    } catch (e) {
        return require(`../resources/images/${imageName}`);
    }
}

export function formatLocaleLong() {
    switch (getLocale()) {
        case 'en':
            return 'en-GB';
        case 'de':
            return 'de-DE';
        case 'fr':
            return 'fr-FR';
        default:
            return 'en-GB';
    }
}

// TODO this is only used in musement requests and should be removed
export function getSelectedCurrency() {
    switch (getLocale()) {
        case 'en':
            return 'GBP';
        case 'de':
        case 'fr':
            return 'EUR';
        default:
            return 'USD';
    }
}

export function resolveTranslationValue(value) {
    if (typeof value === "string") {
        return value;
    }

    if (typeof value === "object" && value !== null) {
        return getTranslation(value, false, true);
    }

    return value;
}